import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

import './App.css';

import { useAuth } from './hook/useAuth';
import { DeckProvider } from './hoc/DeckProvider';
import { CardProvider } from './hoc/CardProvider';
import { SampleProvider } from './hoc/SampleProvider';
import { SetProvider } from './hoc/SetProvider';
import { StorageProvider } from './hoc/StorageProvider';
import DisconectedPage from './pages/DisconectedPage/DisconectedPage';
import AllCardsPage from './pages/AllCardsPage/AllCardsPage';
import CollectionsPage from './pages/CollectionsPage/CollectionsPage';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
import ContentPage from './pages/ContentPage/ContentPage';
import DecksPage from './pages/DecksPage/DecksPage';
import TestPage from './pages/TestPage/TestPage';

/**
 * MTG Keeper application
 * @component
 */
const App = () => {
	const { connected } = useAuth();

	useEffect(() => {
		console.log('Initialization: App');

		// TODO: add server logging
		//notifier.setServerLogHandler
	}, []);

	if (!connected) {
		return <DisconectedPage />;
	} else {
		return (
			<div className="mtgcollection-app">
				<Routes>
					<Route element={<ContentPage title="Collection Management Service" />} path="/" />
					{['/collection', '/collection/:storage_id', '/collection/:storage_id/:sample_id'].map(
						(path, idx) => (
							<Route
								element={
									<StorageProvider>
										<SampleProvider>
											<CollectionsPage layout="default" />
										</SampleProvider>
									</StorageProvider>
								}
								key={idx}
								path={path}
							/>
						)
					)}
					{['/sets', '/sets/:set_id', '/sets/:set_id/:card_id'].map((path, idx) => (
						<Route
							element={
								<StorageProvider>
									<SampleProvider>
										<SetProvider>
											<CardProvider>
												<AllCardsPage layout="default" title="Cards Browser v2" />
											</CardProvider>
										</SetProvider>
									</SampleProvider>
								</StorageProvider>
							}
							key={idx}
							path={path}
						/>
					))}
					{['/decks', '/decks/:deck_id'].map((path, idx) => (
						<Route
							element={
								<DeckProvider>
									<StorageProvider>
										<SampleProvider>
											<DecksPage layout="default" title="Decks" />
										</SampleProvider>
									</StorageProvider>
								</DeckProvider>
							}
							//exact={true}
							key={idx}
							//path={["/decks/:deck_id", "/decks"]}
							path={path}
							// render={(props)=>(
							//     <DecksPage
							//         title="Decks"
							//         layout="default"
							//         authenticated={authenticated}
							//         onSignin={signin}
							//         {...props}
							//     />
							// )}
						/>
					))}
					<Route element={<TestPage />} path="/test" />
					<Route element={<NotFoundPage layout="default" title="Not Found" />} path="*" />
				</Routes>
			</div>
		);
	}
};

App.propTypes = {};

export default App;
